/**
 * The Kiez mark — two heart-headed keys crossed — drawn from the theme.
 *
 * The same geometry as `public/icon.svg`, without its paper tile: the icon
 * file has to carry its own background (a browser tab or a home screen has
 * none to lend it), but here the page is the background, and a baked-in
 * `#FAFAF8` square would sit on the dark theme's `--paper` as a pale tile.
 * So the keys are `--accent` and the holes are `--paper`, both of which the
 * dark theme redefines. If the icon's geometry changes, change this too.
 */
const HEART = 'M0 .9 C-.1 .75 -1 .3 -1 -.25 C-1 -.7 -.55 -.95 -.25 -.9 C-.1 -.87 0 -.75 0 -.6 C0 -.75 .1 -.87 .25 -.9 C.55 -.95 1 -.7 1 -.25 C1 .3 .1 .75 0 .9 Z'

function Key() {
  return (
    <g transform="translate(60 60) rotate(45) scale(0.92) translate(-24.55 -0.14)">
      <path transform="rotate(-90) scale(18)" d={HEART} fill="var(--accent)" />
      <circle cx="-1.8" r="4.68" fill="var(--paper)" />
      <rect x="9" y="-4" width="57.2" height="8" rx="1.5" fill="var(--accent)" />
      <rect x="47.91" y="0" width="8" height="18.29" fill="var(--accent)" />
      <rect x="59.34" y="0" width="6.86" height="12.57" fill="var(--accent)" />
    </g>
  )
}

export function KiezMark({ size = 72, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 120 120"
         role="img" aria-label="Kiez">
      <Key />
      <g transform="translate(120 0) scale(-1 1)"><Key /></g>
    </svg>
  )
}
